import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Icon, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ReactComponent as StartStepLogo } from "../../assets/icons/Tutorial/start-step.svg";
import { ReactComponent as MediaMensal } from "../../assets/icons/Simulador/media-mensal.svg";
import { ReactComponent as Conquistar } from "../../assets/icons/Simulador/conquistar.svg";
import { ReactComponent as Alavancar } from "../../assets/icons/Simulador/alavancar.svg";
import { ReactComponent as Trabalhar } from "../../assets/icons/Simulador/trabalhar.svg";
import { ReactComponent as Ganho } from "../../assets/icons/Simulador/ganho.svg";

function TutorialModal({
  content,
  setCurrentStep,
  transition,
  isHighlightingObserved,
  currentStep,
  setIsOpen,
}) {
  console.log(currentStep);
  const [footer, setFooter] = useState(null);
  const [header, setHeader] = useState(null);

  useEffect(() => {
    switch (currentStep) {
      case 0:
        setFooter(
          <Grid
            className="tutorial-footer"
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            rowGap={"8px"}
          >
            <Grid item>
              <Button
                className="start-button-1"
                variant="contained"
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setCurrentStep(currentStep + 1);
                  transition();
                }}
              >
                Quero ser guiado pelo tutorial
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="start-button-2"
                variant="text"
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setIsOpen(false);
                  transition();
                }}
              >
                Não tenho interesse
              </Button>
            </Grid>
          </Grid>
        );
        setHeader(null);
        break;
      case 10:
        setFooter(
          <Grid
            className="tutorial-footer"
            container
            flexDirection={"row"}
            justifyContent={"center"}
            alignItems={"flex-end"}
          >
            <Grid item>
              <Button
                className="end-button"
                variant="contained"
                onClick={() => {
                  setIsOpen(false);
                  transition();
                }}
              >
                OK
              </Button>
            </Grid>
          </Grid>
        );
        setHeader(null);
        break;
      default:
        setFooter(
          <Grid
            className="tutorial-footer"
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"flex-end"}
          >
            <Grid item>
              <Button
                className="tutorial-button-back"
                variant="text"
                startIcon={<ArrowBackIcon />}
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setCurrentStep(currentStep - 1);
                  transition();
                }}
              >
                Anterior
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="tutorial-button-next"
                variant="contained"
                sx={{
                  textTransform: "none",
                }}
                onClick={() => {
                  setCurrentStep(currentStep + 1);
                  transition();
                }}
              >
                {currentStep === 9 ? "Finalizar tutorial" : "Próximo"}
              </Button>
            </Grid>
          </Grid>
        );
        setHeader(
          <Grid
            className="tutorial-header"
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            sx={{
              maxWidth: "660px",
            }}
          >
            <Grid
              item
              container
              flexDirection={"column"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              rowGap={"8px"}
              xs={10}
            >
              <Grid item>
                <Box className="tutorial-title" component="span">
                  Tutorial Captare
                </Box>
              </Grid>
              <Grid item>
                <Box className="tutorial-subtitle" component="span">
                  Nossas instruções detalhadas e exemplos práticos garantem que
                  mesmo os usuários iniciantes possam rapidamente se
                  familiarizar e utilizar todas as funcionalidades da
                  plataforma.
                </Box>
              </Grid>
            </Grid>
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"flex-end"}
              alignItems={"flex-start"}
              xs={2}
            >
              <IconButton
                className="tutorial-button-close"
                onClick={() => {
                  setIsOpen(false);
                  transition();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        );
        break;
    }
  }, [currentStep]);

  return (
    <Grid
      className="tutorialWrapper"
      container
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"flex-start"}
      style={{
        minWidth: "580px",
        width: "100%",
        height: "100%",
      }}
    >
      {/* HEADER */}
      {header}

      {/* CONTENT */}
      {content}

      {/* FOOTER */}
      {footer}
    </Grid>
  );
}

export const steps = [
  {
    selector: ".tutorial-start-step",
    position: "center",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "100%",
          height: "100%",
          textAlign: "center",
        }}
        rowGap={"12px"}
      >
        <Grid item xs>
          <StartStepLogo
            sx={{
              fontSize: "205px",
            }}
          />
        </Grid>
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={"8px"}
        ></Grid>
        <Grid item xs>
          <Box className="step-title" component={"span"}>
            Seja bem vindo(a) ao tutorial captare !
          </Box>
        </Grid>
        <Grid
          item
          xs
          sx={{
            width: "510px",
          }}
        >
          <Box className="start-step-subtitle" component={"span"}>
            Neste guia abrangente, você será conduzido através dos principais
            passos para dominar a plataforma de análises mais poderosa do
            mercado - Captare. Prepare-se para explorar um universo de insights
            valiosos, possibilitando que você tome decisões estratégicas
            fundamentadas e alcance resultados excepcionais.
          </Box>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-first-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "650px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#b98aee",
                color: "#000000",
                padding: "10px",
              }}
              component={"span"}
            >
              {"Atacar"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "PDV tem melhor potencial para o mercado do que para a Nivea, deve-se ATACAR "
              }
              <span style={{ color: "#8B8B8B" }}>
                {"(alavancar ou promover)"}
              </span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#88d6c3",
                color: "#000000",
                padding: "10px",
              }}
              component={"span"}
            >
              {"Defender"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "PDV tem melhor ou igual potencial para a Nivea do que para o Mercado, deve-se DEFENDER "
              }
              <span style={{ color: "#8B8B8B" }}>
                {"(proteger ou defender)"}
              </span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#ffcbbb",
                color: "#000000",
                padding: "10px",
              }}
              component={"span"}
            >
              {"Pesquisar"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "PDVs com baixo potencial para o Mercado e a Nivea, deve-se PESQUISAR "
              }
              <span style={{ color: "#8B8B8B" }}>{"(crescer ou iniciar)"}</span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs sem compra"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "PDVs que no estudo não tiveram nenhum compra realizada no período do estudo."
              }
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-second-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "650px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"16px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#1EAE60",
                color: "#FFFFFF",
                padding: "10px",
              }}
              component={"span"}
            >
              {"DN TOP"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Soma dos cluster"}
              <span style={{ color: "#AE1E1E" }}>{" HHB "}</span>
              {"+"}
              <span style={{ color: "#AE521E" }}>{" HB "}</span>
              {"+"}
              <span style={{ color: "#AE8E1E" }}>{" MB"}</span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"80px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#8EFFA8",
                color: "#000000",
                padding: "10px",
              }}
              component={"span"}
            >
              {"DN QUALIFICADA"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Soma dos cluster"}
              <span style={{ color: "#AE1E1E" }}>{" HHB "}</span>
              {"+"}
              <span style={{ color: "#AE521E" }}>{" HB "}</span>
              {"+"}
              <span style={{ color: "#AE8E1E" }}>{" MB "}</span>
              {"+"}
              <span style={{ color: "#1E69AE" }}>{" LB"}</span>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-third-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"DN TOP e DN QUALIFICADA"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"É para qualificar os PDVs e com isso facilitar as análises."}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-fourth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Percentual dos PDVs por geografia"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"É um Ranking por PDVs."}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-fifth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Percentual dos PDVs por segmento"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"É um Ranking por segmento."}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-sixth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid
            item
            container
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            xs={5}
          >
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"center"}
              alignContent={"center"}
              sx={{ width: "48px", height: "48px" }}
            >
              <MediaMensal
                style={{
                  scale: "0.6",
                }}
              />
            </Grid>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Média mensal cliente"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Valor médio de receita dividido pelo mesmo número de meses do estudo."
              }
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid
            item
            container
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            xs={5}
          >
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"center"}
              alignContent={"center"}
              sx={{ width: "48px", height: "48px" }}
            >
              <Conquistar
                style={{
                  scale: "0.6",
                }}
              />
            </Grid>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs para conquistar"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Número de PDVs que é possível conquistar a partir de uma estratégia de DEFESA."
              }
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid
            item
            container
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            xs={5}
          >
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"center"}
              alignContent={"center"}
              sx={{ width: "48px", height: "48px" }}
            >
              <Alavancar
                style={{
                  scale: "0.6",
                }}
              />
            </Grid>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs para alavancar"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Número de PDVs que é possível conquistar a partir de uma estratégia de ATAQUE."
              }
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid
            item
            container
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            xs={5}
          >
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"center"}
              alignContent={"center"}
              sx={{ width: "48px", height: "48px" }}
            >
              <Trabalhar
                style={{
                  scale: "0.6",
                }}
              />
            </Grid>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs total a trabalhar"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Total de PDVs para novas oportunidades."}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid
            item
            container
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            xs={5}
          >
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"center"}
              alignContent={"center"}
              sx={{ width: "48px", height: "48px" }}
            >
              <Ganho
                style={{
                  scale: "0.6",
                }}
              />
            </Grid>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Oportunidade de ganho"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Possível geração de receita a partir da aplicação de ações propostas no simulador."
              }
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-seventh-step",
    position: "bottom",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "650px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"66px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#AE1E1E",
                color: "#FFFFFF",
                padding: "10px",
              }}
              component={"span"}
            >
              {"HHB"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Quantidade de PDVs que no cluster de Mercado são HHB e no cluster do cliente possuem uma classificação menor"
              }
              <span style={{ color: "#8B8B8B" }}>
                {" (HB, MB, LB, VLB ou SC - Sem Compra)"}
              </span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"66px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#AE521E",
                color: "#FFFFFF",
                padding: "10px",
              }}
              component={"span"}
            >
              {"HB"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Quantidade de PDVs que no cluster de Mercado são HB e no cluster do cliente possuem uma classificação menor"
              }
              <span style={{ color: "#8B8B8B" }}>
                {" (MB, LB, VLB ou SC - Sem Compra)"}
              </span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"66px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#AE8E1E",
                color: "#FFFFFF",
                padding: "10px",
              }}
              component={"span"}
            >
              {"MB"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Quantidade de PDVs que no cluster de Mercado são MB e no cluster do cliente possuem uma classificação menor"
              }
              <span style={{ color: "#8B8B8B" }}>
                {" (LB, VLB ou SC - Sem Compra)"}
              </span>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item xs={"66px"}>
            <Box
              className="tutorial-step-square"
              sx={{
                backgroundColor: "#1E69AE",
                color: "#FFFFFF",
                padding: "10px",
              }}
              component={"span"}
            >
              {"LB"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Quantidade de PDVs que no cluster de Mercado são LB e no cluster do cliente possuem uma classificação menor"
              }
              <span style={{ color: "#8B8B8B" }}>
                {" (VLB ou SC - Sem Compra)"}
              </span>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-eighth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          maxWidth: "640px",
          width: "100%",
          height: "100%",
        }}
        rowGap={"12px"}
      >
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Total de PDVs"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Número de PDVs que o cliente tem de oportunidade."}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Ticket Medio PDV para cliente"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Valor médio que o PDVs compra do cliente."}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs novos"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"PDVs que não compraram do cliente no período do estudo."}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"PDVs a trabalhar"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {"Volume de PDVs com oportunidade de possível relação comercial."}
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          container
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          columnGap={"8px"}
          xs
        >
          <Grid item>
            <Box
              className="tutorial-step-content"
              sx={{ padding: "10px" }}
              component={"span"}
            >
              {"Oportunidade em reais"}
            </Box>
          </Grid>
          <Grid item xs={"18px"}>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "18px",
              }}
            >
              {"="}
            </Box>
          </Grid>
          <Grid item xs>
            <Box
              className="tutorial-step-content"
              component={"span"}
              sx={{
                fontSize: "14px",
                padding: "10px",
                display: "inline-block",
              }}
            >
              {
                "Totalização em reais das possíveis oportunidades a serem conquistadas."
              }
            </Box>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-ninth-step",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"flex-start"}
        sx={{
          maxWidth: "480px",
          width: "100%",
          height: "100%",
        }}
      >
        <Grid item xs>
          <Box className="tutorial-step-content" component={"span"}>
            <span style={{ color: "#262626" }}>
              {
                "Quantidade de PDVs do cluster do cliente que você gostaria que migrasse para "
              }
            </span>
            <span style={{ color: "#AE1E1E", fontWeight: "700" }}>
              {"HHB "}
            </span>
            <span style={{ color: "#8B8B8B" }}>
              {"(selecione os percentuais)"}
            </span>
          </Box>
        </Grid>
      </Grid>
    ),
  },
  {
    selector: ".tutorial-end-step",
    position: "center",
    content: (
      <Grid
        className="tutorial-content"
        container
        flexDirection={"column"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "100%",
          height: "100%",
          textAlign: "center",
        }}
        rowGap={"12px"}
      >
        <Grid item xs>
          <CheckCircleOutlineIcon
            sx={{
              color: "#4ED04B",
              fontSize: "150px",
            }}
          />
        </Grid>
        <Grid
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={"8px"}
        ></Grid>
        <Grid item xs>
          <Box className="step-title" component={"span"}>
            Tutorial concluído!
          </Box>
        </Grid>
        <Grid
          item
          xs
          sx={{
            width: "510px",
          }}
        >
          <Box className="end-step-subtitle" component={"span"}>
            Desejamos sucesso em suas empreitadas e que o simulador Captare seja
            um instrumento poderoso para o seu crescimento profissional e
            financeiro.
          </Box>
        </Grid>
      </Grid>
    ),
  },
];

export default TutorialModal;
